// バックエンドのバリデーションに合わせている
// https://github.com/graffer-inc/proc-management/blob/develop/backend/src/domain/procedure_master/validation.go

const InputMaxLength = {
  procName: 100,
  procTitle: 50,
  procSummary: 300,
  procDescription: 1000,
  procNotice: 300,
  procTarget: 100,
  procDtlRequirement: 200,
  procTrigger: 200,
  procDeadline: 200,

  onlineInfoNotice: 1000,
  byMailDestAddress: 30,
  byMailDestName: 50,
  submissionName: 50,
  submissionDescription: 300,
  atStoreNotice: 300,
  atStoreFee: 1000,
  documentName: 50,
  documentDescription: 300,
  placeCounterName: 50,

  contactName: 50,
  descriptionFileName: 50,
  referenceName: 50,
  issueFilesName: 50,
  issueFilesDescription: 300,
  issueFilesNotice: 300,
  groupName: 30,

  attachedFileName: 100, // TODO: 添付するファイル自体のファイル名へも文字数制限を入れる。もしくはこちら側でtrimする。
} as const;

export function getMaxLength(fieldName: keyof typeof InputMaxLength) {
  return InputMaxLength[fieldName];
}
